import store from '@/store';
import HTTP from '../../utils/http-common';

const check = async (to, from, next) => {
  const isValid =
    (await HTTP.get(`/temp-tokens/supplier-valid?token=${to.query.tempToken}&psCode=${to.params.supplierCode}`)).data >
    0;
  if (isValid || store.getters.isAuthenticated) {
    return next();
  }
  next('/');
};
const appPromoRequestsRoutes = [
  {
    path: '/promo-requests/:soapAction/:supplierCode',
    name: 'promo-requests/index',
    component: () => import('@/portals/PromoRequests'),
    beforeEnter: check
  }
];
export { appPromoRequestsRoutes as default };
